export enum ValuationLevel {
  ONE = 'ONE',
  TWO = 'TWO',
  THREE = 'THREE',
}

export enum EPCRating {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
}

export enum FeeType {
  PRODUCT_FEE = 'PRODUCT_FEE',
  VALUATION_FEE = 'VALUATION_FEE',
}

export enum FeeStatus {
  NEW = 'NEW',
  PENDING = 'PENDING',
  PAID = 'PAID',
  FAILED = 'FAILED',
  REFUNDED = 'REFUNDED',
  CANCELLED = 'CANCELLED',
}

export type Fee = {
  id: string;
  caseId: string;
  type: FeeType;
  amount: number;
  status: FeeStatus;
  createdAt: Date;
  updatedAt: Date;
};

export type Valuation = {
  id: string;
  level: ValuationLevel;
  fee: Fee;
  propertyId: string;
  instructionDate?: Date;
  inspectionDate?: Date;
  reportDate?: Date;
  instructionBookingConfirmedDate?: Date;
  instructionBookedDate?: Date;
  reportReceivedDate?: Date;
  valuationExpiryDate?: Date | null;
  valuationAmount?: number;
  reinstatementCost?: number;
  epcProvider?: string;
  epcRating?: EPCRating;
  isNewBuild?: boolean;
  hasNhbcCertificate?: boolean;
  createdAt: Date;
  updatedAt: Date;
};
